import actionTypes from 'constants/actionTypes'
import single from './single'
import defaultsDeep from 'lodash/defaultsDeep'
import cloneDeep from 'lodash/cloneDeep'
import reduce from 'lodash/reduce'
import { isHardFail } from 'lib/action'

interface BookmarkInput {
  id?: string
  content?: string
  nodeIds?: string[]
  [key: string]: unknown
}

type BookmarksAllState = Record<string, ReturnType<typeof single>>

interface BookmarkAction {
  type?: string
  Type?: string
  payload?: {
    id?: string
    data?: BookmarkInput
  }
  previousPayload?: {
    id?: string
  }
}


const all = (state: BookmarksAllState = {}, action: BookmarkAction): BookmarksAllState => {
  const actionType = action.type ?? ''
  switch (true) {
    case actionType === actionTypes.BOOKMARKS.ONE.CREATE.REQUEST: {
      const id = action.payload?.id
      if (!id) return state
      return defaultsDeep(
        {
          [id]: single(state[id], action, { id })
        },
        state
      )
    }
    case actionType === actionTypes.BOOKMARKS.ONE.CREATE.RECEIVE: {
      const id = (action.payload?.data as BookmarkInput | undefined)?.id
      if (!id) return state
      return defaultsDeep(
        {
          [id]: single(state[id], action, { id })
        },
        state
      )
    }
    case actionType === actionTypes.BOOKMARKS.ONE.CREATE.FAIL: {
      const id = action.previousPayload?.id
      if (!id) return state
      if (isHardFail(action)) {
        const updated = cloneDeep(state)
        delete updated[id]
        return updated
      }
      return defaultsDeep(
        {
          [id]: single(state[id], action, { id })
        },
        state
      )
    }
    case [
      actionTypes.BOOKMARKS.ONE.START_EDITING,
      actionTypes.BOOKMARKS.ONE.STOP_EDITING,
      actionTypes.BOOKMARKS.ONE.EDIT.REQUEST,
      actionTypes.BOOKMARKS.ONE.DELETE.REQUEST
    ].includes(actionType): {
      const id = action.payload?.id
      if (!id) return state
      return defaultsDeep(
        {
          [id]: single(state[id], action, { id })
        },
        state
      )
    }
    case actionType === actionTypes.BOOKMARKS.ONE.EDIT.RECEIVE: {
      const id = (action.payload?.data as BookmarkInput | undefined)?.id
      if (!id) return state
      return defaultsDeep(
        {
          [id]: single(state[id], action, { id })
        },
        state
      )
    }
    case [
      actionTypes.BOOKMARKS.ONE.EDIT.FAIL,
      actionTypes.BOOKMARKS.ONE.DELETE.FAIL
    ].includes(actionType): {
      const id = action.previousPayload?.id
      if (!id) return state
      return defaultsDeep(
        {
          [id]: single(state[id], action, { id })
        },
        state
      )
    }
    case actionType === actionTypes.BOOKMARKS.ONE.DELETE.RECEIVE: {
      const id = action.previousPayload?.id
      if (!id) return state
      const updated = cloneDeep(state)
      delete updated[id]
      return updated
    }
    case action.Type === actionTypes.BOOKMARKS.MULTI.GET_ALL.RECEIVE:
      return reduce((Array.isArray(action.payload?.data) ? (action.payload?.data as BookmarkInput[]) : []), (bs: BookmarksAllState, b: BookmarkInput) => {
        const bookmarkId = b.id
        if (!bookmarkId) return bs
        return defaultsDeep(
          {
            [bookmarkId]: single(state[bookmarkId], action, b)
          },
          bs
        )
      }, state)
    default:
      return state
  }
}

export default all
